import { Sha256 } from '@aws-crypto/sha256-js';
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';

export const hash = async (string) => {
    const utf8 = new TextEncoder().encode(string);
    const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((bytes) => bytes.toString(16).padStart(2, "0"))
        .join("");
    return hashHex;
};
export const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};

export const sha256 = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const hash = new Sha256();
    hash.update(arrayBuffer);
    const hashBuffer = await hash.digest();
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((bytes) => bytes.toString(16).padStart(2, "0"))
        .join("");
    return hashHex
};

export const htmlToPdf = {
    getPdf(title) {
        html2Canvas(document.querySelector('#pdfDom'), {
            scale: 2,
            allowTaint: true,
        }).then(canvas => { //内容的宽度
            let contentWidth = canvas.width; //内容高度
            let contentHeight = canvas.height; //一页pdf显示html页面生成的canvas高度,a4纸的尺寸[595.28,841.89];
            let pageHeight = contentWidth / 592.28 * 841.89; //未生成pdf的html页面高度
            let leftHeight = contentHeight; //页面偏移
            let position = 0; //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
            let imgWidth = 595.28;
            let imgHeight = 592.28 / contentWidth * contentHeight; //canvas转图片数据
            let pageData = canvas.toDataURL('image/jpeg', 1.0); //新建JsPDF对象
            let PDF = new JsPDF('p', 'pt', 'a4'); //判断是否分页
            if (leftHeight < pageHeight) {
                PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
            } else {
                while (leftHeight > 0) {
                    PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
                    leftHeight -= pageHeight;
                    position -= 841.89;
                    if (leftHeight > 0) {
                        PDF.addPage()
                    }
                }
            } //保存文件
            PDF.save(title + '.pdf')
        })
    }
};

export const verifyReportToPdf = {
    getPdf(title) {
        let PDF = new JsPDF('p', 'pt', 'a4');
        html2Canvas(document.querySelector('#pdfDom'), {
            scale: 2,
            allowTaint: true,
        }).then(canvas => {
            let contentWidth = canvas.width;
            let contentHeight = canvas.height;
            let pageHeight = contentWidth / 592.28 * 841.89;
            let leftHeight = contentHeight;
            let position = 0;
            let imgWidth = 595.28;
            let imgHeight = 592.28 / contentWidth * contentHeight;
            let pageData = canvas.toDataURL('image/jpeg', 1.0);
            
            if (leftHeight < pageHeight) {
                PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
            } else {
                while (leftHeight > 0) {
                    PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
                    leftHeight -= pageHeight;
                    position -= 841.89;
                    if (leftHeight > 0) {
                        PDF.addPage()
                    }
                }
            }
        }).then(
            PDF.save(title + '.pdf')
        )
    }
};